import SearchBar from "../SearchBar/SearchBar";
import AddModalQuestionCategoryList from "../Modals/AddModalQuestionCategoryList";
import {
  fetchQuestionWithAnswerCategory,
  setPage,
} from "../../store/slices/apiQuestionCategorySlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Pagination } from "../../components";
import TableItemsQuestionWithCategory from "../TableItemsQuestionWithCategory/TableItemsQuestionWithCategory";
import TableItemsQuestionWithCategoryResponsive from "../TableItemsQuestionWithCategory/TableItemsQuestionWithCategoryResponsive";

const TableListQuestionCategory = () => {
  const dispatch = useDispatch();

  const backendBaseUrl = "https://back2.autoshkollaime.com";
  const dataQuestion = useSelector(
    (state) => state.apiQuestionCategory.dataQuestion
  );

  const currentPage = useSelector(
    (state) => state.apiQuestionCategory.currentPage
  );
  const totalCount = useSelector(
    (state) => state.apiQuestionCategory.totalCount
  );

  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    dispatch(
      fetchQuestionWithAnswerCategory({
        page: currentPage,
        searchQuery: searchInput,
      })
    );
  }, [dispatch, currentPage, searchInput]);

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    dispatch(
      fetchQuestionWithAnswerCategory({
        page: currentPage,
        searchQuery: searchInput,
      })
    );
  };

  const handlePageChange = (page) => {
    dispatch(setPage(page));
  };

  return (
    <div className="p-3">
      <div className="flex items-center justify-between pb-4 bg-white dark:bg-gray-900">
        <SearchBar
          searchInput={searchInput}
          handleSearchInputChange={handleSearchInputChange}
          handleSearchSubmit={handleSearchSubmit}
        />
        <div>
          <button className="text-danger mx-2" alt="you can edit here">
            <AddModalQuestionCategoryList
              title="Shto një pyetje me kategori"
              submitButtonText="Shto pyetjen"
            />
          </button>
        </div>
      </div>
      <div className="w-full overflow-x-auto">
        <div className="min-w-[900px] overflow-x-scroll shadow-md sm:rounded-lg">
          <div className="hidden sm:block">
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    Emri i Pyetjes
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Kategoria
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Sub Kategoria
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Ikona
                  </th>

                  <th scope="col" className="px-6 py-3">
                    Piket
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                <TableItemsQuestionWithCategory
                  dataQuestionCategory={dataQuestion}
                  baseUrl={backendBaseUrl}
                />
              </tbody>
            </table>
          </div>

          <div className="block sm:hidden space-y-4">
            <TableItemsQuestionWithCategoryResponsive
              dataQuestionCategory={dataQuestion}
              baseUrl={backendBaseUrl}
            />
          </div>
          <Pagination
            currentPage={currentPage}
            totalCount={totalCount}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default TableListQuestionCategory;
